import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/Login';
import Application from '@/components/Application';
import Applications from '@/components/Applications';
import BillingLists from '@/components/BillingLists';
import BillingListDraft from '@/components/BillingListDraft';
import BillingListConfirmed from '@/components/BillingListConfirmed';
import Contracts from '@/components/Contracts';
import CrewList from '@/components/CrewList';
import Dashboard from '@/components/Dashboard';
import DocumentType from '@/components/DocumentType';
import DocumentTypes from '@/components/DocumentTypes';
import Entity from '@/components/Entity';
import Entities from '@/components/Entities';
import InternalOffice from '@/components/InternalOffice';
import InternalOffices from '@/components/InternalOffices';
import MaritimeObject from '@/components/MaritimeObject';
import MaritimeObjects from '@/components/MaritimeObjects';
import OtherDatabases from '@/components/OtherDatabases';
import Placement from '@/components/Placement';
import Placements from '@/components/Placements';
import Profile from '@/components/Profile';
import Rank from '@/components/Rank';
import Ranks from '@/components/Ranks';
import Bank from '@/components/Bank';
import Banks from '@/components/Banks';
import Seafarers from '../components/Seafarers';
import Seafarer from '../components/Seafarer';
import Statistics from '../components/Statistics.vue';
import UserAccounts from '../components/UserAccounts';
import UserAccount from '../components/UserAccount';
import Vacancies from '@/components/Vacancies';
import Vacancy from '@/components/Vacancy';
import Invoices from '@/components/Invoices';
import Invoice from '@/components/Invoice';
import Payslips from '@/components/Payslips';
import Airport from '@/components/Airport';
import Airports from '@/components/Airports';

import Projects from '@/components/Projects';
import Project from '@/components/Project';

Vue.use(Router);

export default new Router({
    routes: [
        {path: '/applications/:id', name: 'application', component: Application, meta: {}},
        {path: '/applications', name: 'applications', component: Applications, meta: {}},
        {path: '/billing-lists', name: 'billingLists', component: BillingLists, meta: {}},
        {path: '/billing-list-draft/:id', name: 'billingListDraft', component: BillingListDraft, meta: {}},
        {path: '/billing-list-confirmed/:id', name: 'billingListConfirmed', component: BillingListConfirmed, meta: {}},
        {path: '/contracts', name: 'contracts', component: Contracts, meta: {}},
        {path: '/crew-list', name: 'crewwList', component: CrewList, meta: {}},
        {path: '/dashboard', name: 'dashboard', component: Dashboard, meta: {}},
        {path: '/document-types', name: 'documentTypes', component: DocumentTypes, meta: {}},
        {path: '/document-types/:id', name: 'documentType', component: DocumentType, meta: {}},
        {path: '/entities/:id', name: 'entity', component: Entity, meta: {}},
        {path: '/entities', name: 'entities', component: Entities, meta: {}},
        {path: '/internal-offices/:id', name: 'internalOffice', component: InternalOffice, meta: {}},
        {path: '/internal-offices', name: 'internalOffices', component: InternalOffices, meta: {}},
        {path: '/login', name: 'login', component: Login, meta: {}},
        {path: '/maritime-objects/:id', name: 'maritime-object', component: MaritimeObject, meta: {}},
        {path: '/maritime-objects', name: 'maritime-objects', component: MaritimeObjects, meta: {}},
        {path: '/other-databases', name: 'otherDatabases', component: OtherDatabases, meta: {}},
        {path: '/placements/:id', name: 'placement', component: Placement, meta: {}},
        {path: '/placements', name: 'placements', component: Placements, meta: {}},
        {path: '/profile', name: 'profile', component: Profile, meta: {}},
        {path: '/ranks', name: 'ranks', component: Ranks, meta: {}},
        {path: '/ranks/:id', name: 'rank', component: Rank, meta: {}},
        {path: '/banks', name: 'banks', component: Banks, meta: {}},
        {path: '/banks/:id', name: 'bank', component: Bank, meta: {}},
        {path: '/seafarers', name: 'seafarers', component: Seafarers, meta: {}},
        {path: '/seafarers/:id/:tab?', name: 'seafarer', component: Seafarer, meta: {}},
        {path: '/statistics', name: 'statistics', component: Statistics, meta: {}},
        {path: '/user-accounts', name: 'userAccounts', component: UserAccounts, meta: {}},
        {path: '/user-accounts/:id', name: 'userAccount', component: UserAccount, meta: {}},
        {path: '/vacancies', name: 'vacancies', component: Vacancies, meta: {}},
        {path: '/vacancies/:id', name: 'vacancy', component: Vacancy, meta: {}},
        {path: '/invoices', name: 'invoices', component: Invoices, meta: {}},
        {path: '/invoices/:id', name: 'invoice', component: Invoice, meta: {}},
        {path: '/invoices/:id/:billing', name: 'invoice', component: Invoice, meta: {}},
        {path: '/payslips', name: 'payslips', component: Payslips, meta: {}},
        {path: '/airports', name: 'airports', component: Airports, meta: {}},
        {path: '/airports/:id', name: 'airport', component: Airport, meta: {}},

        {path: '/projects', name: 'projects', component: Projects, meta: {}},
        {path: '/projects/:id', name: 'project', component: Project, meta: {}},
    ],
});
